// extracted by mini-css-extract-plugin
export var arrow = "_dh-1";
export var content = "_dh-0";
export var highlighted = "_dh-2";